module.exports = __webpack_public_path__ + "img/klarna.b6c2551.svg";